import { render, staticRenderFns } from "./PolicyMotorRiskDetails.vue?vue&type=template&id=1df4cc6c&"
import script from "./PolicyMotorRiskDetails.vue?vue&type=script&lang=js&"
export * from "./PolicyMotorRiskDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports